module.exports = __webpack_public_path__ + "img/img10_1.e00ed051.svg";